import { ChakraProvider } from '@chakra-ui/react';

import { Calendar, EventDetailModal } from './components/calendar';
import {
	CalendarSettingsProvider,
	FiltersProvider,
	ModalProvider,
	CalendarViewProvider,
	EventPositionProvider,
	ContainerWidthProvider,
	CalendarDataProvider,
	ShortcodeSettingsProvider,
} from '../src/lib';
import { theme } from './theme';

import './style.scss';

const CalendarPlus: React.FunctionComponent = () => {
	return (
		<ChakraProvider theme={theme}>
			<ShortcodeSettingsProvider>
				<CalendarSettingsProvider>
					<CalendarDataProvider>
						<FiltersProvider>
							<CalendarViewProvider>
								<ModalProvider>
									<EventPositionProvider>
										<ContainerWidthProvider>
											<Calendar />
										</ContainerWidthProvider>
										<EventDetailModal />
									</EventPositionProvider>
								</ModalProvider>
							</CalendarViewProvider>
						</FiltersProvider>
					</CalendarDataProvider>
				</CalendarSettingsProvider>
			</ShortcodeSettingsProvider>
		</ChakraProvider>
	);
};

export default CalendarPlus;
